import Fuse from "fuse.js"
import {endpoints} from "../constants/API"
import urlParams from "../utility/UrlParams"
import {parseJsonColorData} from "../utility/Helper"
import {BikeType} from "../utility/Types"

export const handleSearch = (value, router, setResults, setLoading) => {
	if (value.length >= 3) {
		fetch(`${endpoints.search}?locale=${router.locale}&term=${value}&limit=${15}&offset=${0}`).then(res => res.json())
			.then(res => {
				const bikes = res.direct?.bikes.concat(res.other?.bikes)
				const accessories = res.direct?.accessories
				const totalNumberOfProducts = res.direct?.totalNumberOfProducts
				const searchSuggestions = res.direct?.searchSuggestions
				const autoCorrect = res.direct?.autoCorrect
				setResults(() => {
					return {
						bikes,
						accessories,
						totalNumberOfProducts,
						searchSuggestions,
						autoCorrect
					}
				})
				setLoading(false)
			}).catch(error => console.error(error))
	} else {
		setResults(prev => prev)
		setLoading(false)
	}
}

export const handleLightningSearch = async (value, router, baseParams, organizationSlug, setResults, setLoading) => {
	fetch(`${endpoints.thunderProducts}?params=${JSON.stringify({categories: "-", [urlParams.searchValue]: value})}&${baseParams}&organization=${organizationSlug}`).then(data => data?.json()).then(data => {
		const bikes = data.direct?.bikes.concat(data.other?.bikes)
		const accessories = data.direct?.accessories
		const totalNumberOfProducts = data.direct?.totalNumberOfProducts
		const searchSuggestions = data.direct?.searchSuggestions
		const autoCorrect = data.direct?.autoCorrect
		setResults(() => (
			{
				bikes,
				accessories,
				totalNumberOfProducts,
				searchSuggestions,
				autoCorrect
			}
		))
		if (bikes?.length) {
			setLoading(() => false)
		}
	})
}

export const performSearchOnFrontEnd = (term, result1:{bikes:BikeType[], accessories:BikeType[]}, setResults, setLoading) => {
	const bikesFuse = new Fuse(result1?.bikes, {
		keys: ["name", "slug", "description", "attributes.terms.name", "categories.name", "variation_objects.sku"], ignoreLocation: true, includeMatches: true
	})
	const accessoriesFuse = new Fuse(result1?.accessories, {
		keys: ["name", "slug", "description", "attributes.terms.name", "categories.name", "variation_objects.sku"], ignoreLocation: true, includeMatches: true
	})
	const searchResults = bikesFuse.search(term)
	const bikesResults = searchResults?.slice(0, 10)?.map(bike => {
		try {
			return {
				...bike?.item,
				colorData: parseJsonColorData(bike?.item.color_data),
				customInstanceDiscounts: JSON.parse(bike?.item?.customInstanceDiscounts as unknown as string || "{}")
			}
		} catch (error) {
			return {
				...bike?.item,
				customInstanceDiscounts: JSON.parse(bike?.item?.customInstanceDiscounts as unknown as string || "{}"),
				colorData: parseJsonColorData(bike?.item?.color_data)
			}
		}
	})

	const searchesResults = accessoriesFuse.search(term)

	const accessoriesResults = searchesResults?.slice(0, 10).map(result => {
		try {
			return {
				...result?.item,
				colorData: parseJsonColorData(result?.item.color_data),
				customInstanceDiscounts: JSON.parse(result?.item?.customInstanceDiscounts as unknown as string || "{}")

			}
		} catch (error) {
			return {
				...result?.item,
				colorData: parseJsonColorData(result?.item?.color_data),
				customInstanceDiscounts: JSON.parse(result?.item?.customInstanceDiscounts as unknown as string || "{}")
			}
		}
	})

	const searchSuggestions = []
	let suggestionsIndex = 0
	for (const bike of bikesResults.slice(0, 10)) {
		if (bike?.name?.toLowerCase().startsWith(term.toLowerCase())) {
			searchSuggestions.push(bike?.name)
			suggestionsIndex++
		}

		if (suggestionsIndex === 10) {
			break
		}
	}

	const autoCorrect = []

	if (searchSuggestions.length === 0) {
		let autoCorrectIndex = 0
		for (const bike of bikesResults.slice(0, 10)) {
			if (!autoCorrect.includes(bike?.name?.split(" ")?.[0])) {
				autoCorrect.push(bike?.name?.split(" ")?.[0])
				autoCorrectIndex++
			}

			if (autoCorrectIndex === 10) {
				break
			}
		}
	}

	setResults(() => {
		return {
			bikes: bikesResults?.filter(Boolean),
			accessories: accessoriesResults,
			// totalNumberOfProducts,
			searchSuggestions,
			autoCorrect
		}
	})
	setLoading(false)
}
